import React, { Component } from 'react';

import moment from 'moment-with-locales-es6';
import axios from 'axios';
import { connect} from "remx";
import broker from '../../../utils/broker';
import config from '../../../utils/config';
import dataStore from '../../../stores/data';
import ChartMonaBulan from '../../../components/Charts/ChartMonaBulan';



const month_name = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'];


class ChartPelanggan extends Component {
    constructor(props) {
        super(props);
    
        this.options = {
          sortIndicator: true,
          hideSizePerPage: true,
          paginationSize: 6,
          hidePageListOnlyOnePage: true,
          clearSearch: true,
          alwaysShowAllBtns: false,
          withFirstAndLast: false
        }
        this.state = {
          reload:false,
          loading: false,
          data : {},
          keterangan : '',
          image_url : '',
          data_rate: {},
        }
      }

      getDataTraffic(){
        var year = moment(this.props.date_view).locale('id').format('Y');
        broker.fetchSupport.get(`generate_graphic?id=${this.props.pelanggan_id}&month=${parseInt(this.props.month_view)+1}&year=${year}`)
        .then(res => {
            const { data } = res;
            if (data) {
                this.setState({data : data}, function(){
                  this.renderChart();
                });
            } else {

            }
        }).catch(err => {
            
        });
      }

      getDataTrafficDaily(){
        broker.fetchSupport.get(`generate_graphic_daily?id=${this.props.pelanggan_id}&date=${moment(this.props.date_view).locale('id').format('YYYY-MM-DD') }`)
        .then(res => {
            const { data } = res;
            if (data) {
                this.setState({data : data}, function(){
                  this.renderChart();
                });
            } else {

            }
        }).catch(err => {
            
        });
      }


      componentDidMount(){
        if (this.props.type_view === 'day'){
            this.getDataTrafficDaily();
            this.setState({keterangan : 'Tgl. ' + moment(this.props.date_view).locale('id').format('DD MMMM YYYY')});
        } else {
            this.getDataTraffic();
            this.setState({keterangan : 'Bulan ' + month_name[this.props.month_view]});
        }
      }

      componentDidUpdate(prevProps, prevState) {
          if (this.props.type_view !== prevProps.type_view ||
            this.props.month_view !== prevProps.month_view ||
            this.props.date_view !== prevProps.date_view ||
            this.props.pelanggan_id !== prevProps.pelanggan_id ||
            this.props.show_map !== prevProps.show_map) {
             
              if (this.show_map) {
                if (this.props.type_view === 'day'){
                    this.getDataTrafficDaily();
                    this.setState({keterangan : 'Tgl. ' + moment(this.props.date_view).locale('id').format('DD MMMM YYYY')});
                } else {
                    this.getDataTraffic();
                    this.setState({keterangan : 'Bulan ' + month_name[this.props.month_view]});
                }
              }

          }

          if (this.state.image_url !== prevState.image_url) {
            var data_export = {
                                pelanggan_id: this.props.pelanggan_id, 
                                no_urut_pelanggan : this.props.no_urut_pelanggan,
                                klasifikasi : this.props.klasifikasi,
                                sub_klasifikasi: this.props.sub_klasifikasi,
                                nama_pelanggan : this.state.data.nama_pelanggan,
                                image_url : this.state.image_url, 
                                rate : this.state.data_rate,
            };       
            dataStore.setters.setDataExport(this.props.data_export.concat(data_export));
          }
      }

      renderChart(){
        var option = {
              chart: {
                  type: 'column',
              },
              legend: {
                  enabled: false
              },
              title: {
                  text: 'Data ' + this.state.data.nama_pelanggan + ' ' + this.state.keterangan,
                  x: -20
              },
              subtitle: {
                  text: '<span style="color:#00CC33;">Download</span>' + '<br>' +
                      '<span style="color:#0000FF;">Upload</span>',
                  x: -20
              },
              xAxis: {
                  categories: this.state.data.category
              },
              yAxis: {
                  max: this.state.data.pelanggan.max_download,
                  min : this.state.data.rate.upload_min,
                  title: {
                      text: 'Bandwidth'
                  },
                  plotLines: [{
                      value:  (this.state.data.pelanggan) ? this.state.data.pelanggan.max_download : 0,
                      color: 'red',
                      width: 2,
                      zIndex: 5
                  }]
              },
              tooltip: {
                  formatter: function () {
                      var tooltip;
                      if (this.series.name == 'Download') {
                          tooltip = '<span style="color:' + this.series.color + '">' + this.series
                              .name + '</span>: <b>' + this.point
                              .stackTotal + ' Mbps</b><br/>';
                      } else {
                          tooltip = '<span style="color:' + this.series.color + '">' + this.series
                              .name + '</span>: <b>' + this.y +
                              ' Mbps</b><br/>';
                      }
                      return tooltip;
                  }
              },
              plotOptions: {
                  column: {
                      stacking: 'normal',
                      pointPadding: 0,
                      borderWidth: 0
                  },
                  series: {
                      pointPadding: 0,
                      groupPadding: 0,
                      animation: false
                  }
              },
              credits: {
                  enabled: false
              },
              exporting: {
                  width: 900
              },
              series: this.state.data.series,
      
          };

          var object = {
            options: JSON.stringify(option),
            type: 'image/png',
            async: true
          };

          axios.post(`${config.api_export}`, object)
          .then(res => {
              const { data } = res;
              if (data) {
                  this.setState({image_url : `${data}`, pelanggan_id : this.props.pelanggan_id, data_rate : this.state.data.rate});
              } else {
  
              }
          }).catch(err => {
              
          });

      }


      
    render(){
        if (this.state.data.rate && this.state.image_url){
          return(
            <div className="mg-b-50 col-sm-12">
            {/* <div className="mg-b-50 mg-l-100" style={{width: '85%'}}> */}
              <img src={`${config.api_export}/${this.state.image_url}`} style={{width:'100%'}}/>
              <table className="table table-bordered mg-b-0">
              <tbody>
                <tr>
                  <th scope="row">Upload</th>
                  <td>Current</td>
                  <td>{this.state.data.rate.upload_current} Mbps</td>
                  <td>Average</td>
                  <td>{this.state.data.rate.upload_avg} Mbps</td>
                  <td>Max</td>
                  <td>{this.state.data.rate.upload_max} Mbps</td>
                </tr>
                <tr>
                  <th scope="row">Download</th>
                  <td>Current</td>
                  <td>{this.state.data.rate.download_current} Mbps</td>
                  <td>Average</td>
                  <td>{this.state.data.rate.download_avg} Mbps</td>
                  <td>Max</td>
                  <td>{this.state.data.rate.download_max} Mbps</td>
                </tr>
              </tbody>
            </table>
            </div> 
          );
        } else {
          return null;
        }
        
    }

}

function mapStateToProps(props) {
    return {
      type_view : dataStore.getters.getDataTypeView(),
      year_view : dataStore.getters.getDataYearView(),
      month_view : dataStore.getters.getDataMonthView(),
      date_view : dataStore.getters.getDataDateView(),
      form_view : dataStore.getters.getDataFormView(),
      data_export : dataStore.getters.getDataExport(),
      data_kategori_per : dataStore.getters.getDataKategoriPer(),
    }
}


export default connect(mapStateToProps)(ChartPelanggan);